import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faList } from '@fortawesome/sharp-solid-svg-icons';
import Link from 'next/link';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';
import Typography from '@/components/typography';
import { GLOBAL_TOOLTIP } from '@/constants/constants';
import { INSIGHTS_CATALOG_URL } from '@/constants/urls';
import { InsightsCatalogLayerClass } from '@/features/insightsCatalog/models';
import { useInsightsCatalogContext } from '@/features/insightsCatalog/provider';

type Props = {
  layer: InsightsCatalogLayerClass;
};

/** @deprecated */
export const LayersOverlayRow: React.FC<Props> = ({ layer }) => {
  const { changeLayerActive, setLegendLayerId } = useInsightsCatalogContext();

  return (
    <div className="group flex h-[48px] max-w-[360px] items-center justify-between bg-gray-90 px-4 py-2 hover:bg-gray-100">
      {/* Title */}
      <div className="flex items-center gap-x-3 truncate">
        <div
          className={twMerge(
            'border-whiteborder flex h-3 w-3 rounded-full border-[2px]',
            layer.isPrivate ? 'bg-blue-utility' : 'bg-yellow-utility'
          )}
        />

        <Link
          className="flex-1 truncate text-white"
          href={`${INSIGHTS_CATALOG_URL}/${layer.id}`}
        >
          <Typography
            className="truncate text-white"
            data-tooltip-content={layer.name}
            data-tooltip-delay-show={500}
            data-tooltip-id={GLOBAL_TOOLTIP}
          >
            {layer.name}
          </Typography>
        </Link>
      </div>

      {/* Buttons */}
      <div className="flex items-center">
        {/* Legend Button */}
        <div
          className={twMerge(
            'flex hidden items-center justify-center group-hover:flex'
          )}
          data-tooltip-content="View Legend"
          data-tooltip-delay-show={500}
          data-tooltip-id={GLOBAL_TOOLTIP}
        >
          <IconButton
            className={twMerge(
              'flex items-center justify-center dark:text-white dark:hover:bg-gray-90'
            )}
            size={ButtonSize.SMALL}
            variant={ButtonVariant.GHOST}
            onClick={(e) => {
              e.stopPropagation();
              setLegendLayerId(layer.id);
            }}
          >
            <div className="flex items-center justify-center ">
              <FontAwesomeIcon icon={faList} size="sm" />
            </div>
          </IconButton>
        </div>

        {/* Enable disable */}
        {/* Div to push the pin icon over when eyeball not present */}
        <div
          className={twMerge(
            layer.enabled ? 'hidden' : 'h-[32px] w-[32px] group-hover:hidden'
          )}
        />
        <div
          className="flex items-center justify-center"
          data-tooltip-content={layer.enabled ? 'Hide' : 'Show'}
          data-tooltip-delay-show={500}
          data-tooltip-id={GLOBAL_TOOLTIP}
        >
          <IconButton
            className={twMerge(
              'flex items-center justify-center dark:text-white dark:hover:bg-gray-90',
              layer.enabled ? 'block' : 'hidden group-hover:block'
            )}
            size={ButtonSize.SMALL}
            variant={ButtonVariant.GHOST}
            onClick={(e) => {
              e.stopPropagation();
              changeLayerActive(layer.id, !layer.enabled);
            }}
          >
            <div className="flex items-center justify-center ">
              <FontAwesomeIcon
                icon={layer.enabled ? faEye : faEyeSlash}
                size="sm"
              />
            </div>
          </IconButton>
        </div>
      </div>
    </div>
  );
};
